module.exports = __webpack_public_path__ + "img/icon-clue.393ea295.png";